/* the translate pipe translates a string using the Language Service */

import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../Services/lang'; // ourtranslate service
import { Observable } from 'rxjs/Observable';


@Pipe({
  name: 'translate',
})

export class TranslatePipe implements PipeTransform {

	constructor(private _lang: LanguageService) { }

	transform(value: string, emptyIfNone: boolean, args: any[]): Observable<string> {

		return this._lang.translate(value, emptyIfNone);
	}
}



// WEBPACK FOOTER //
// ./src/app/Pipes/translate.ts